export const TableHelpers = {
    data() {
        return {
            tableColumns : [
                {
                    title: this.$t('mail_internal_name'),
                    type: 'text',
                    className: 'font-weight-bold job-title',
                    key: 'name',
                    sortable: true,

                },
                {
                    title: this.$t('title'),
                    type: 'text',
                    className: 'font-weight-bold job-title',
                    key: 'title',
                    sortable: true,

                },
                {
                    title: this.$t('preview'),
                    type: 'custom-html',
                    key: 'body',
                    isVisible: true,
                    modifier: (value) => {
                        // summernote saves html or plain text, always give html and convert to plain text
                        if(value !== null){
                            let shareText = value.replace(/<div>/g, "%0D%0A").replace(/<br>/g, "%0D%0A%0D%0A").replace(/<li>/g, "%0D%0A– ").replace(/<ul>/g, "%0D%0A").replace(/(<([^>]+)>)/gi, "");

                            let advertText = $('<div>'+value+'</div>').text();
                            let length = 60;
                            let trimmedString = advertText.length > length ?
                                                advertText.substring(0, length - 3) + "..." :
                                                advertText;
                            return `<div class="job-post" data-share="`+shareText+`">`+trimmedString+`</div>`;
                        }

                    }

                },
                {
                    title: this.$t('date_created'),
                    type: 'custom-html',
                    sortable: true,
                    key: 'created_at',
                    isVisible: true,
                    modifier: (value) => {

                        let date = new Date(value);
                        let dateOptions = { timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit' };
                        let dateCreated = date.toLocaleString('cs-CZ', dateOptions);

                        return `${dateCreated}`;
                    }
                },
                {
                    title: this.$t('date_updated'),
                    type: 'custom-html',
                    sortable: true,
                    key: 'updated_at',
                    isVisible: false,
                    modifier: (value) => {

                        let date = new Date(value);
                        let dateOptions = { timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit' };
                        let dateUpdated = date.toLocaleString('cs-CZ', dateOptions);

                        return `${dateUpdated}`;
                    }
                },

            ],
            actionObj : {
                title: this.$t('action'),
                type: 'action',
            }
        }
    },
}
